import { render, staticRenderFns } from "./flightPassengerList.vue?vue&type=template&id=24fc5ebc&scoped=true&"
import script from "./flightPassengerList.vue?vue&type=script&lang=ts&"
export * from "./flightPassengerList.vue?vue&type=script&lang=ts&"
import style1 from "./flightPassengerList.vue?vue&type=style&index=1&id=24fc5ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc5ebc",
  null
  
)

export default component.exports